import { useEffect, useState } from "react";
import { generateOnlineBillLink, generateOTPForNewCustomerRegisteration, newCustomerRegisteration, sendMessage } from "../../api/api";
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { ManualPaymentForm, NoValidateForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Button, Checkbox, Col, Divider, Form, List, Modal, Row, Steps } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import CustomTextArea from "../../components/_common/CustomTextArea";
import { SmileOutlined, MailOutlined, CheckCircleFilled, UserOutlined, DesktopOutlined, FileDoneOutlined, DeleteFilled } from '@ant-design/icons';
import CustomSelect from "../../components/_common/CustomSelect";
import CustomSelectAntDesign from "../../components/_common/CustomSelectAntDesign";

export const LabInstallationRequestDialog: React.FC<FormProps> = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {
    const { register } = useForm(NoValidateForm) as any;
    var otpVlueDecode = ''
    var curentSteper = 0
    const { values, errors, handleSubmit, setErrors, setValues }
        = useForm(NoValidateForm) as any
    const [FormState, SetFormState] = useState(0);
    const [waitforOTP, setWaitForOTP] = useState(false);
    const [OTP, setOTP] = useState("");
    const [test, setOTPTest] = useState("");
    const [nextButtonTitle, SetNextButtonTitle] = useState('ارسال کد اعتبار سنجی');
    const [previousButtonTitle, SetPreviousButtonTitle] = useState('خروج');
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [labNameValid, setLabNameValid] = useState('')
    const [requesterNameValid, setrequesterNameValid] = useState('')
    const [ownerMobileNumberValid, setOwnerMobileNumberValid] = useState('')
    const [emailValid, setEmailValid] = useState('')
    const [mobileNumberValid, setMobileNumberValid] = useState('')
    const [otpValid, setOtpValid] = useState('')

    const [labOwnerName, setLabOwnerNameValid] = useState('')
    const [directTel, setDirectTelValid] = useState('')
    const [address, setAddressValid] = useState('')
    const [postalCode, setPostalCodeValid] = useState('')

    const [isPhatology, setIsPhatology] = useState(false);
    const [isGenetics, setIsGenetics] = useState(false);
    const [isTax, setIsTax] = useState(false);
    const [isContractValue, setIsContract] = useState(true);
    const [isInvoiceValue, setIsInvoice] = useState(true);

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type];
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    const [inputValues, setInputValue] = useState({
        labName: "",
        mobileNumber: "",
        email: "",
        otp: '',
        labOwnerName: '',
        directTel: '',
        address: '',
        postalCode: '',
        perviousApp: '',
        antiVirusSoftwareName: '',
        totalNumberOfComputers: '',
        state: '0',
        isPhatology: false,
        isGenetics: false,
        isTax: false,
        bit_Contract: true,
        bit_Invoice: true,
        requster: '',
        ownerMobileNumber: '',
        admitInDay: '',
        establishmentDate: ''

    });

    const [validation, setValidation] = useState({
        labName: "",
        mobileNumber: "",
        email: "",
        otp: '',
        labOwnerName: '',
        directTel: '',
        address: '',
        postalCode: '',
        perviousApp: '',
        antiVirusSoftwareName: '',
        totalNumberOfComputers: '',
        isPhatology: '',
        isGenetics: '',
        isTax: '',
        requster: '',
        ownerMobileNumber: ''

    });

    //handle submit updates
    function handleChange(event: any) {

        if (event.target.name == 'directTel' && event.target.value.length == 12) {
            event.stopPropagation();
            return
        }
        if (event.target.name == 'postalCode' && event.target.value.length == 11) {
            event.stopPropagation();
            return
        }
        const { name, value } = event.target;
        // if (event.target.type == "checkbox") {
        //     setInputValue({ ...inputValues, [name]: event.target.checked });
        // }
        if (event.target.name == 'isGenetics') {
            if (event.target.checked) {
                setIsGenetics(event.target.checked);
            }
            else {
                setIsGenetics(false);
            }

        }
        if (event.target.name == 'isPhatology') {
            if (event.target.checked) {
                setIsPhatology(event.target.checked);
            }
            else {
                setIsPhatology(false);
            }
        }
        if (event.target.name == 'isTax') {
            if (event.target.checked) {
                setIsTax(event.target.checked);
            }
            else {
                setIsTax(false);
            }
        }
        if (event.target.name == 'isContract') {
            if (event.target.checked) {
                setIsContract(event.target.checked);
            }
            else {
                setIsContract(false);
            }
        }
        if (event.target.name == 'isInvoice') {
            if (event.target.checked) {
                setIsInvoice(event.target.checked);
            }
            else {
                setIsInvoice(false);
            }
        }

        if (event.target.type == "select-one") {

            setInputValue({ ...inputValues, [name]: event.target.value });
        }
        else
            setInputValue({ ...inputValues, [name]: value });

    }

    const cehckValidUser = (errors: any) => {
        let mobileRegex = new RegExp('^(\\+98|0)?9\\d{9}$');
        //first Name validation
        if (!inputValues.labName.trim()) {
            errors.labName = "نام آزمایشگاه را وارد کنید";
            setLabNameValid("نام آزمایشگاه را وارد کنید")
        }
        else if (inputValues.labName.trim().length < 2) {
            errors.labName = "نام آزمایشگاه حداقل دو حرفی میباشد";
            setLabNameValid("نام آزمایشگاه حداقل دو حرفی میباشد")
        }
        else {
            errors.labName = "";
            setLabNameValid('')
        }
        if (!inputValues.mobileNumber.trim()) {
            errors.mobileNumber = "موبایل را وارد کنید";
            setMobileNumberValid("موبایل را وارد کنید")
        }
        else if (!mobileRegex.test(inputValues.mobileNumber)) {
            errors.mobileNumber = "موبایل را به درستی وارد کنید";
            setMobileNumberValid("موبایل را به درستی وارد کنید")
        }
        else {
            errors.mobileNumber = "";
            setMobileNumberValid('')
        }
        if (!inputValues.ownerMobileNumber.trim()) {
            errors.ownerMobileNumber = "موبایل صاحب اصلی را وارد کنید";
            setOwnerMobileNumberValid("موبایل صاحب اصلی را وارد کنید")
        }
        else if (!mobileRegex.test(inputValues.ownerMobileNumber)) {
            errors.mobileNuownerMobileNumbermber = "موبایل را به درستی وارد کنید";
            setOwnerMobileNumberValid("موبایل را به درستی وارد کنید")
        }
        else {
            errors.ownerMobileNumber = "";
            setOwnerMobileNumberValid('')
        }
        if (!inputValues.requster.trim()) {
            errors.requester = "نام درخواست دهنده را وارد کنید";
            setrequesterNameValid("نام درخواست دهنده را وارد کنید")
        }
        else {
            errors.requester = "";
            setrequesterNameValid('')
        }
        return errors
    }

    const cehckValidOtp = (errors: any) => {
        if (!inputValues.otp.trim()) {
            errors.otp = "رمز را وارد کنید";
            setOtpValid("رمز را وارد کنید")

        }
        else if (inputValues.otp.trim() != OTP) {
            errors.otp = "رمز به درستی وارد نشده";
            setOtpValid("رمز به درستی وارد نشده")
        }
        else {
            errors.otp = "";
            setOtpValid('')
        }
        return errors
    }

    const cehckSaveInfoUser = (errors: any) => {

        if (!inputValues.labOwnerName.trim()) {
            errors.labOwnerName = "نام صاحب اصلی را وارد کنید";
            setLabOwnerNameValid("نام صاحب اصلی را وارد کنید")
        }
        else if (inputValues.labOwnerName.trim().length < 2) {
            errors.labOwnerName = "نام صاحب اصلی حداقل دو حرفی میباشد";
            setLabOwnerNameValid("نام صاحب اصلی حداقل دو حرفی میباشد")
        }
        else {
            errors.labOwnerName = "";
            setLabOwnerNameValid('')
        }

        if (!inputValues.directTel.trim()) {
            errors.directTel = "تلفن ثابت (مثلا :02144804472) را وارد کنید";
            setDirectTelValid("تلفن ثابت (مثلا :02144804472) را وارد کنید")
        }
        else if (inputValues.directTel.trim().length != 11) {
            errors.directTel = "شماره تلفن را به درستی وارد کنید";
            setDirectTelValid("شماره تلفن را به درستی وارد کنید")
        }
        else {
            errors.directTel = "";
            setDirectTelValid('')
        }
        if (!inputValues.address.trim()) {
            errors.address = "آدرس را وارد کنید";
            setAddressValid("آدرس را وارد کنید")
        }
        else if (inputValues.address.trim().length < 10) {
            errors.address = " آدرس  حداقل ده حرفی میباشد";
            setAddressValid("  آدرس حداقل ده حرفی میباشد")
        }
        else {
            errors.address = "";
            setAddressValid('')
        }
        if (!inputValues.postalCode.trim()) {
            errors.postalCode = "کد پستی را وارد کنید";
            setPostalCodeValid("کد پستی را وارد کنید")
        }
        else if (inputValues.postalCode.trim().length != 10) {
            errors.postalCode = "   کد پستی  ده رقم میباشد";
            setPostalCodeValid("  کد پستی  ده رقم میباشد")
        }
        else {
            errors.postalCode = "";
            setPostalCodeValid('')
        }
        return errors
    }

    const checkValidation = () => {

        let errors = validation;
        errors = cehckValidUser(errors)
        errors = cehckValidOtp(errors)
        errors = cehckSaveInfoUser(errors)
        setValidation(errors);
    };

    useEffect(() => {
        if (payLoad.state !== null && payLoad.machineList !== null) setIsLoading(false);
        console.log(payLoad);
        checkValidation();
    }, [inputValues, payLoad])

    const [curent, setCurent] = useState(0)

    const ProgressIndicator = () => {
        // current={curent}
        return (
            <Steps size={"small"} current={curent} onChange={(e) => {

            }}>
                <Steps.Step title={"ورود"} icon={<UserOutlined />} />
                <Steps.Step title={"رمز یک بار مصرف"} icon={<MailOutlined />} />
                <Steps.Step title={"ثبت اطلاعات"} icon={<FileDoneOutlined />} />
                <Steps.Step title={"آنالایزرها"} icon={<DesktopOutlined />} />
                <Steps.Step title={"اتمام"} icon={<SmileOutlined />} />
            </Steps>


        )
    }

    const onNextClick = (e: any) => {
        e.preventDefault();
        if (FormState == 0 &&
            (validation.email.length > 0 || validation.labName.length > 0
                || validation.mobileNumber.length > 0)) {
            errorNotify('موارد مشخص شده را پر کنید', undefined, 5000)
            return
        }

        if (FormState == 0 && waitforOTP &&
            (validation.otp.length > 0)) {
            errorNotify('موارد مشخص شده را پر کنید', undefined, 5000)
            return
        }

        if ((FormState == 1) &&
            ((validation.totalNumberOfComputers.length > 0) ||
                (validation.address.length > 0) ||
                (validation.antiVirusSoftwareName.length > 0) ||
                (validation.directTel.length > 0) ||
                (validation.isGenetics.length > 0) ||
                (validation.isPhatology.length > 0) ||
                (validation.isTax.length > 0) ||
                (validation.labOwnerName.length > 0) ||
                (validation.perviousApp.length > 0) ||
                (validation.postalCode.length > 0))
        ) {
            errorNotify('موارد مشخص شده را پر کنید', undefined, 5000)
            return
        }

        if ((FormState == 2) && (values.installMachineVlabInstallRequests == undefined)) {
            errorNotify('حداقل یک آیتم را انتخاب کنید', undefined, 5000)
            return
        }
        if ((FormState == 2) && (values.installMachineVlabInstallRequests != undefined)


        ) {
            if (values.installMachineVlabInstallRequests.length == 0) {
                errorNotify('حداقل یک آیتم را انتخاب کنید', undefined, 5000)
                return
            }
        }

        if (FormState == 3)
            setCurent(5)
        switch (FormState) {
            case 0:
                if (!waitforOTP) {
                    setIsSubmiting(true)
                    // curentSteper = 1
                    setCurent(1)
                    generateOTPForNewCustomerRegisteration(
                        inputValues.mobileNumber,
                        inputValues.labName,
                        inputValues.email || ""
                    )
                        .then((result: any) => {
                            console.log(result.data.data);
                            sucessNotify("رمز یکبار مصرف به شماره موبایل و ایمیل شما ارسال شد", undefined, 5000)
                            setIsSubmiting(false)
                            setWaitForOTP(true)
                            console.log('res is', result.data.data.code)
                            let str = result.data.data.code
                            console.log('str is', str)
                            setOTP(atob(atob(result.data.data.code).replaceAll('/', '').replaceAll('+', '').replaceAll('=', '')).replaceAll('/', '').replaceAll('+', '').replaceAll('=', ''))
                            setOTPTest(str)
                            otpVlueDecode = atob(atob(result.data.data.code).replaceAll('/', '').replaceAll('+', '').replaceAll('=', '')).replaceAll('/', '').replaceAll('+', '').replaceAll('=', '')
                            console.log('val is', test)
                            console.log('val is', OTP)
                            console.log('otpVlueDecode is', otpVlueDecode)

                            SetNextButtonTitle('ثبت کد ورود')
                        })
                        .catch((error) => {
                            console.log(error);
                            setIsSubmiting(false)
                            errorNotifyByErrorObject(error, undefined, 5000)
                        })
                }
                else {

                    if (1 === 1) {
                        setCurent(2)
                        SetFormState(1);
                        SetNextButtonTitle('بعدی')
                        setValues((val: any) => ({
                            ...val,
                            state: '0',
                            isPhatology: false,
                            isGenetics: false,
                            isTax: true
                        }))
                    }
                    else {
                        errorNotify("رمز یکبار مصرف وارد شده صحیح نمی باشد", undefined, 5000)
                    }
                }
                break;

            case 1:
                SetFormState(2);
                setCurent(3)
                SetNextButtonTitle('بعدی')
                break;
            case 2:
                setCurent(4)
                let model: any = {};

                inputValues.isGenetics = isGenetics;
                inputValues.isPhatology = isPhatology;
                inputValues.isTax = isTax;
                inputValues.bit_Contract = isContractValue;
                inputValues.bit_Invoice = isInvoiceValue;

                setIsSubmiting(true);

                model = inputValues;
                model['state'] = +inputValues.state
                model['installMachineVlabInstallRequests'] = values.installMachineVlabInstallRequests
                model['startUsingSoftware'] = '';
                model['admitInDay'] = inputValues.admitInDay  ? parseInt(inputValues.admitInDay, 10): 0; 
                newCustomerRegisteration(model)
                        .then((result: any) => {
                            console.log(result.data.data);
                            sucessNotify("اطلاعات شما با موفقیت ثبت گردید", undefined, 5000)
                            setIsSubmiting(false);
                            SetNextButtonTitle('');
                            SetFormState(3);
                            // if (inputValues.isContract)
                            //     _sendMessage(inputValues.labName);
                        })
                        .catch((error) => {
                            console.log(error);
                            setIsSubmiting(false)
                            errorNotifyByErrorObject(error, undefined, 5000)
                        })

                break;
            case 3:
            default:
                break;
        }
    }

    const _sendMessage = (labName: string) => {
        let msgText = "آزمایشگاه " + labName + " درخواست ارسال قرارداد دارد.";
        let phoneNumbers: string[] = [];

        phoneNumbers.push("09123105310");
        phoneNumbers.push("09120187829");

        sendMessage(msgText, phoneNumbers)
            .then((result: any) => {
                //setIsSubmiting(false);
                sucessNotify("پیامک درخواست قرارداد ارسال شد.");
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const onPreviousClick = () => {
        onCancel();
    }

    const machineHandleChanges = (id: any) => {
        //handleChange(event);
        let selectedMachine = payLoad.machineList.find((machine: any) => machine.prk_MachineInfo_AutoID == id);
        let findSelected = values.installMachineVlabInstallRequests ?
            values.installMachineVlabInstallRequests.
                find((item: any) => item.machineId == selectedMachine.prk_MachineInfo_AutoID) : null;
        if (findSelected) {
            errorNotify('این دستگاه قبلا انتخاب شده است', undefined, 5000)
            return
        }
        if (selectedMachine) {

            let myMachineList = values.installMachineVlabInstallRequests
            if (!myMachineList) {
                myMachineList = [{
                    machineVlabInstallRequestId: 0,
                    labInstallRequestId: 0,
                    machineId: selectedMachine.prk_MachineInfo_AutoID,
                    machineName: selectedMachine.str_MachineName
                }]
            }
            else {
                myMachineList.push({
                    machineVlabInstallRequestId: 0,
                    labInstallRequestId: 0,
                    machineId: selectedMachine.prk_MachineInfo_AutoID,
                    machineName: selectedMachine.str_MachineName
                })
            }


            setValues((val: any) => ({
                ...val,
                installMachineVlabInstallRequests: myMachineList
            }))
        }

    }

    const machineHandleChanges_manual = (machineName: any) => {
        let myMachineList = values.installMachineVlabInstallRequests
        if (!myMachineList) {
            myMachineList = [{ machineVlabInstallRequestId: 0, labInstallRequestId: 0, machineId: 0, machineName }]
        }
        else {
            myMachineList.push({ machineVlabInstallRequestId: 0, labInstallRequestId: 0, machineId: 0, machineName })
        }


        setValues((val: any) => ({
            ...val,
            installMachineVlabInstallRequests: myMachineList
        }))

    }

    const removeMachineFromList = (index: any) => {

        let myMachineList = [
            ...values.installMachineVlabInstallRequests.slice(0, index),
            ...values.installMachineVlabInstallRequests.slice(index + 1),
        ]

        setValues((val: any) => ({
            ...val,
            installMachineVlabInstallRequests: myMachineList
        }))

    }

    const checkedEventChange = (e: any) => {
        setValues((val: any) => ({
            ...val,
            [e.target.name]: e.target.checked
        }))
    }

    return (
        <Modal
            width={800}
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                    <Spinner />
                )}

                {isLoading === false && (

                    <FormContainer

                        title="ثبت نام مشتری جدید"
                        saveButtonTitle={nextButtonTitle}
                        onSubmit={onNextClick} cancelButtonTitle={previousButtonTitle}
                        onCancel={onPreviousClick} isLoading={isLoading} isSubmiting={isSubmiting} >

                        <Row>
                            <ProgressIndicator />
                        </Row>
                        <Divider />

                        {FormState === 0 && waitforOTP === false && (
                            <>
                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <div className="form-control"
                                            style={{ marginBottom: '18px' }} >
                                            <input
                                                placeholder="  "
                                                type="string"
                                                autoComplete="false"
                                                name="labName"
                                                id="labName"
                                                className="input-field"
                                                onChange={(e) => handleChange(e)}
                                                value={inputValues.labName}

                                            />
                                            {(() => {
                                                if (labNameValid.length > 0) {
                                                    return <p
                                                        className="position-ab top-30"
                                                        style={{
                                                            color: 'red', fontSize: '12px', textAlign: 'right',
                                                            paddingRight: '17px', paddingTop: '5px'
                                                        }}
                                                    >
                                                        {labNameValid}
                                                    </p>

                                                }
                                            })()}

                                            {/* {validation.labName.length>0 && <p
                                                style={{ color: 'red', fontSize: '12px', textAlign: 'right',
                                                 paddingRight: '17px', paddingTop: '5px' }}>
                                                    {validation.labName}
                                                    </p>} */}

                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <div className="form-control"
                                            style={{ marginBottom: '18px' }} >
                                            <input
                                                placeholder="  "
                                                type="string"
                                                autoComplete="false"
                                                name="requster"
                                                id="requster"
                                                className="input-field"
                                                onChange={(e) => handleChange(e)}
                                                value={inputValues.requster}

                                            />
                                            {(() => {
                                                if (requesterNameValid.length > 0) {
                                                    return <p
                                                        className="position-ab top-30"
                                                        style={{
                                                            color: 'red', fontSize: '12px', textAlign: 'right',
                                                            paddingRight: '17px', paddingTop: '5px'
                                                        }}
                                                    >
                                                        {requesterNameValid}
                                                    </p>

                                                }
                                            })()}
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <div className="form-control"
                                            style={{ marginBottom: '18px' }} >
                                            <input
                                                placeholder="ایمیل (اختیاری)"
                                                type="email"
                                                autoComplete="false"
                                                name="email"
                                                className="input-field"
                                                onChange={(e) => handleChange(e)}
                                                value={inputValues.email}
                                            />
                                            {emailValid.length > 0 && <p
                                                style={{ color: 'red', fontSize: '12px', textAlign: 'right', paddingRight: '17px', paddingTop: '5px' }}
                                            >{emailValid}</p>}
                                        </div>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <div className="form-control"
                                            style={{ marginBottom: '18px' }} >
                                            <input
                                                placeholder=" "
                                                type="number"
                                                autoComplete="false"

                                                id="mobileNumber"
                                                name="mobileNumber"
                                                className="input-field"
                                                onChange={(e) => handleChange(e)}
                                                value={inputValues.mobileNumber}
                                            />
                                            {mobileNumberValid.length > 0 && <p
                                                className="position-ab top-30"
                                                style={{ color: 'red', fontSize: '12px', textAlign: 'right', paddingRight: '17px', paddingTop: '5px' }}
                                            >{mobileNumberValid}</p>}
                                        </div>
                                    </Col>
                                </Row>

                                {/* <Row>otp
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomTextArea
                                            name="labName"
                                            placeholder="نام کامل آزمایشگاه"
                                            value={values.labName}
                                            onChange={handleChange}
                                        />
                                        <ValidationType type="labName" />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomTextArea
                                            name="email"
                                            placeholder="ایمیل (اختیاری)"
                                            value={values.email}
                                            onChange={handleChange}
                                        />
                                        <ValidationType type="email" />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomTextArea
                                            name="mobileNumber"
                                            placeholder="شماره موبایل"
                                            value={values.mobileNumber}
                                            onChange={handleChange}
                                        />
                                        <ValidationType type="mobileNumber" />
                                    </Col>
                                </Row> */}

                            </>
                        )}

                        {FormState === 0 && waitforOTP === true && (
                            <>
                                <Row>
                                    <Col>
                                        <label>
                                            <span style={{ display: 'inline-block' }}>
                                                آزمایشگاه محترم
                                            </span>

                                            <span style={{ padding: "0px 5px", color: '#0093ff', display: 'inline-block' }}>{inputValues.labName}</span>

                                            به شماره موبایل
                                            <span style={{ padding: "0px 5px", color: '#0093ff', display: 'inline-block' }}>
                                                {inputValues.mobileNumber}
                                            </span>

                                            <span style={{ paddingLeft: "5px" }}></span>
                                            لطفا کد ارسال شده را وارد نمایید
                                        </label>
                                    </Col>
                                    <Col lg={24} md={24} sm={24} xs={24}>

                                        <input
                                            name="otp"

                                            type="number"

                                            placeholder="   "
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.otp}
                                        />
                                        {otpValid.length > 0 && <p
                                            className="position-ab top-30"
                                            style={{
                                                color: 'red', fontSize: '12px', textAlign:
                                                    'right', paddingRight: '17px', paddingTop: '5px'
                                            }}
                                        >{otpValid}</p>}
                                        <ValidationType type="otp" />

                                    </Col>
                                </Row>

                            </>
                        )}

                        {FormState === 1 && (
                            <>

                                <Row>
                                    <Col lg={8} md={8} sm={12} xs={24}>
                                        <CustomTextArea
                                            name="labOwnerName"
                                            // placeholder="نام صاحب اصلی یا مسئول فنی"
                                            placeholder=" "
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.labOwnerName}
                                        />
                                        {labOwnerName.length > 0 && <p
                                            className="position-ab top-30"
                                            style={{
                                                color: 'red', fontSize: '12px', textAlign:
                                                    'right', paddingRight: '17px', paddingTop: '5px'
                                            }}
                                        >{labOwnerName}</p>}
                                        <ValidationType type="labOwnerName" />
                                    </Col>
                                    <Col lg={8} md={8} sm={12} xs={24}>
                                        <CustomTextArea
                                            name="ownerMobileNumber"
                                            placeholder=" "
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.ownerMobileNumber}
                                        />
                                        {ownerMobileNumberValid.length > 0 && <p
                                            className="position-ab top-30"
                                            style={{
                                                color: 'red', fontSize: '12px', textAlign:
                                                    'right', paddingRight: '17px', paddingTop: '5px'
                                            }}
                                        >{ownerMobileNumberValid}</p>}
                                        <ValidationType type="ownerMobileNumberValid" />
                                    </Col>
                                    <Col lg={8} md={8} sm={12} xs={24}>
                                        <input
                                            className="width-fill mx-5"
                                            name="directTel"

                                            placeholder=""
                                            type="number"
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.directTel}
                                        />
                                        {directTel.length > 0 && <p
                                            className="position-ab top-30"
                                            style={{
                                                color: 'red', fontSize: '12px', textAlign:
                                                    'right', paddingRight: '17px', paddingTop: '5px'
                                            }}
                                        >{directTel}</p>}
                                        <ValidationType type="directTel" />
                                    </Col>
                                    <Col lg={8} md={8} sm={12} xs={24}>
                                        <input
                                            className="width-fill mx-5"
                                            name="postalCode"
                                            placeholder=""
                                            type="number"
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.postalCode}
                                        />
                                        {postalCode.length > 0 && <p
                                            className="position-ab top-30"
                                            style={{
                                                color: 'red', fontSize: '12px', textAlign:
                                                    'right', paddingRight: '17px', paddingTop: '5px'
                                            }}
                                        >{postalCode}</p>}
                                        <ValidationType type="postalCode" />
                                    </Col>
                                    <Col lg={8} md={8} sm={12} xs={24}>
                                        <input
                                            name="totalNumberOfComputers"
                                            placeholder="تعداد کامپیوتر"
                                            type="number"
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.totalNumberOfComputers}
                                        />

                                        <ValidationType type="totalNumberOfComputers" />
                                    </Col>
                                    <Col lg={8} md={8} sm={12} xs={24}>
                                        <CustomTextArea
                                            name="perviousApp"
                                            placeholder="نرم افزار قبلی"
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.perviousApp}
                                        />

                                        <ValidationType type="perviousApp" />
                                    </Col>
                                    <Col lg={8} md={8} sm={12} xs={24}>
                                        <CustomTextArea
                                            name="antiVirusSoftwareName"
                                            placeholder="آنتی ویروس"
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.antiVirusSoftwareName}
                                        />

                                        <ValidationType type="antiVirusSoftwareName" />
                                    </Col>
                                    <Col lg={8} md={8} sm={12} xs={24}>
                                        <CustomTextArea
                                            name="admitInDay"
                                            placeholder="تعداد پذیرش در ماه"
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.admitInDay}
                                        />
                                    </Col>
                                    <Col lg={8} md={8} sm={12} xs={24}>
                                        <CustomTextArea
                                            name="establishmentDate"
                                            placeholder="تاریخ تاسیس"
                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.establishmentDate}
                                        />
                                    </Col>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomTextArea
                                            name="address"
                                            placeholder=" "

                                            onChange={(e) => handleChange(e)}
                                            value={inputValues.address}
                                        />
                                        {address.length > 0 && <p
                                            className="position-ab top-30"
                                            style={{
                                                color: 'red', fontSize: '12px', textAlign:
                                                    'right', paddingRight: '17px', paddingTop: '5px'
                                            }}
                                        >{address}</p>}
                                        <ValidationType type="address" />
                                    </Col>
                                    <Col lg={8} md={8} sm={12} xs={24} style={{ marginBottom: '9px' }}>
                                        <CustomSelect

                                            name="state"
                                            placeholder="استان"
                                            itemList={payLoad.state}
                                            value={inputValues.state || '0'}
                                            onChange={(e) => handleChange(e)}

                                            valueObjectField={"prk_State_AutoID"}
                                            displayObjectField={"str_StateName"}

                                        />
                                        <ValidationType type="state" />

                                    </Col>
                                    <Col lg={16} md={16} sm={24} xs={24}>
                                        <div style={{ 'display': 'flex', 'justifyContent': 'space-between' }}>
                                            <Checkbox
                                                name="isPhatology"

                                                onChange={(e) => handleChange(e)}
                                                checked={isPhatology}
                                            >
                                                {"آزمایشگاه پاتولوژی هم دارد"}
                                            </Checkbox>
                                            <Checkbox
                                                name="isGenetics"

                                                onChange={(e) => handleChange(e)}
                                                checked={isGenetics}
                                            >
                                                {"آزمایشگاه ژنتیک هم دارد"}
                                            </Checkbox>
                                            <Checkbox
                                                name="isTax"
                                                onChange={(e) => handleChange(e)}
                                                checked={isTax}
                                            >
                                                {"تمامی فاکتورها مالیاتی باشد"}
                                            </Checkbox>
                                        </div>
                                    </Col>
                                </Row>

                                <Row></Row>

                                <Row style={{ textAlign: 'right' }}>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <Checkbox
                                            name="isContract"
                                            onChange={(e) => handleChange(e)}
                                            checked={isContractValue}
                                        >
                                            {"آزمایشگاه درخواست ارسال قرارداد دارد"}
                                        </Checkbox>
                                    </Col>
                                    <Col lg={12} md={12} sm={24} xs={24}>
                                        <Checkbox
                                            name="isInvoice"
                                            onChange={(e) => handleChange(e)}
                                            checked={isInvoiceValue}
                                        >
                                            {"آزمایشگاه درخواست فاکتور دارد"}
                                        </Checkbox>
                                    </Col>
                                </Row>


                                <Row>

                                    {/* <Col lg={24} md={24} sm={24} xs={24}>
                                       
                                      
                                    </Col>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        
                                      
                                    </Col> */}
                                </Row>

                            </>
                        )}

                        {FormState === 2 && (
                            <>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CustomSelectAntDesign
                                            name="machine"
                                            placeholder="آنلایزر"
                                            itemList={payLoad.machineList}
                                            valueObjectField={"prk_MachineInfo_AutoID"}
                                            displayObjectField={"str_MachineName"}
                                            showSearch={true}
                                            onChange={(e: any) => machineHandleChanges(e)}
                                            onPressEnter={(e: any) => machineHandleChanges_manual(e)}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <List
                                            header={
                                                <Row>
                                                    <Col lg={23} md={23} sm={23} xs={23}>لیست</Col>
                                                </Row>
                                            }
                                            style={{ margin: '10px' }}
                                            footer={undefined}
                                            bordered
                                            dataSource={values.installMachineVlabInstallRequests}
                                            renderItem={(item: any, index: any) => (
                                                <List.Item actions={
                                                    [
                                                        <DeleteFilled onClick={() => removeMachineFromList(index)} style={{ color: 'red', fontSize: '18px' }} />,
                                                    ]
                                                }>
                                                    <>
                                                        <List.Item.Meta
                                                            description={item.machineName}
                                                        />
                                                    </>
                                                </List.Item>
                                            )}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )}

                        {FormState === 3 && (
                            <>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <CheckCircleFilled style={{ color: 'green', fontSize: '64px', margin: '10px' }} />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col lg={24} md={24} sm={24} xs={24}>
                                        <p>ثبت نام شما با موفقیت انجام شد. نام کاربری و اطلاعات آموزشی برای شما پیامک گردید</p>
                                    </Col>
                                </Row>

                            </>
                        )}


                    </FormContainer>

                )}
            </>

        </Modal>
    )
}